const SocialsIndex = () => import('./views/SocialsIndex.vue')
const SocialsCreate = () => import('./views/SocialsCreate.vue')
const SocialsEdit = () => import('./views/SocialsEdit.vue')

export default [
  {
    path: 'socials',
    name: 'socials.index',
    component: SocialsIndex
  },
  {
    path: 'socials/create',
    name: 'socials.create',
    component: SocialsCreate
  },
  {
    path: 'socials/:socialId(\\d+)',
    name: 'socials.edit',
    component: SocialsEdit
  }
]
